module.exports = __webpack_public_path__ + "img/L_530_0.490a49ed.png";